var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,7c-2.7,0-5.2,1.4-6.5,3.8V6h-2v8h8v-2h-4.4C17,9.3,20.3,8.2,23,9.6s3.8,4.7,2.4,7.4 c-0.9,1.8-2.8,3-4.9,3H20v2h0.5c4.1,0,7.5-3.4,7.5-7.5C28,10.4,24.6,7,20.5,7C20.5,7,20.5,7,20.5,7L20.5,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,4H2v3.2l7.4,7.4l0.6,0.6V24h4v-2h2v2c0,1.1-0.9,2-2,2h-4c-1.1,0-2-0.9-2-2v-8L0.6,8.6 C0.2,8.2,0,7.7,0,7.2V4c0-1.1,0.9-2,2-2h0h22V4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFilter);
export default __webpack_public_path__ + "static/media/reset_filter.96821e4f53b7c33f1b1433354974f8a9.svg";
export { ForwardRef as ReactComponent };